<template>
  <v-container grid-list-lg>
    <v-row>
      <v-col>
        <v-card class="elevation-0 transparent">
          <v-card-title class="headline">Nový výrobný príkaz</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <ValidationObserver ref="form">
                  <form class="text-left" @submit.prevent="submit">
                    <ValidationProvider v-slot="{ errors }" name="Name" rules="required|max:20">
                      <v-text-field
                        v-model="manufacturingCommand.name"
                        hint="odporúčaný typ názvu: VP_OBJ_17_19_20"
                        label="Názov"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ errors }" name="Description">
                      <v-text-field
                        v-model="manufacturingCommand.description"
                        label="Popis"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                    <v-btn color="primary" type="submit">Uložiť</v-btn>
                  </form>
                </ValidationObserver>
              </v-col>
              <v-col cols="8">
                <v-data-table
                  v-model="manufacturingCommand.ManufacturingDetails"
                  :headers="orderDetailsTableHeader"
                  :items="unprocessedOrderDetails"
                  item-key="orderDetailId"
                  show-select
                  class="elevation-0 transparent"
                  dense
                >
                  <template v-slot:top>
                    <v-toolbar flat color="white" class="transparent">
                      <v-toolbar-title>Výber položiek do výrobného príkazu</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                      <v-text-field append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-toolbar>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UnitOfWorkService from "@/services/UnitOfWorkService";
import { orderDetailsTableHeader } from "@/views/manufacturing_command/js/tableHeaders";

export default {
  name: "Order",
  components: {},
  data: () => ({
    manufacturingCommand: {
      name: "VP_OBJ_"
    },
    orderDetailsTableHeader: orderDetailsTableHeader,
    unprocessedOrderDetails: []
  }),

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.openGlobalLoader("Načítava sa ...");
      new UnitOfWorkService()
        .orderService()
        .getUnprocessedOrderDetails()
        .then(response => {
          this.unprocessedOrderDetails = response.data;
        })
        .finally(() => {
          this.closeGlobalLoader();
        });
    },

    submit() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        this.openGlobalLoader("Ukladá sa ...");
        new UnitOfWorkService()
          .manufacturingCommandService()
          .postManufacturingCommand(this.manufacturingCommand)
          .then(response => {
            console.log(response);
            this.$router.push("/manufacturing-commands");
          })
          .finally(() => {
            this.closeGlobalLoader();
          });
      });
    }
  }
};
</script>
